const refreshStore = {
  state: {
    // invoice: null,
    incoming: null,
  },
  getters: {
    // invoice(state) {
    //   return state.invoice;
    // },
    incoming(state) {
      return state.incoming;
    },
  },
  mutations: {
    // INVOICE_UPDATE(state, update) {
    //   state.invoice = update;
    // },
    INCOMING_UPDATE(state, update) {
      state.incoming = update;
    },
  },
};

export default refreshStore;
